module.exports = __webpack_public_path__ + "img/labchile-teva.f04c44f3.png";